module.exports = __webpack_public_path__ + "img/5-ancho.33dd6847.jpg";